import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/AppLayout";
import { FrontDoor } from "./components/FrontDoor";
import { Loading } from "./components/Notice";
import { AccessRefused } from "./screens/AccessRefused";
import { DeviceRecoveries } from "./screens/DeviceRecoveries";
import { Notifications } from "./screens/Notifications";
import { Referrals } from "./screens/Referrals";
import { SignIn } from "./screens/SignIn";
import { Staff } from "./screens/Staff";
import { UserDetail } from "./screens/UserDetail";
import { useSession } from "./session/SessionContext";

export function App() {
  const { status, error, refresh, logout, staff } = useSession();

  if (status === "loading") {
    return (
      <div className="centered">
        <Loading size="lg" />
      </div>
    );
  }

  if (status === "anonymous") return <SignIn />;
  if (status === "refused") return <AccessRefused />;

  if (status === "unreachable") {
    return (
      <FrontDoor
        title="The API did not answer"
        actions={
          <>
            <button type="button" onClick={logout}>
              Sign out
            </button>
            <button type="button" className="primary" onClick={refresh}>
              Try again
            </button>
          </>
        }
      >
        <p className="subtle">{error}</p>
      </FrontDoor>
    );
  }

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Referrals />} />
        <Route path="/users/:userId" element={<UserDetail />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route
          path="/staff"
          element={staff?.role === "admin" ? <Staff /> : <Navigate to="/" replace />}
        />
        <Route
          path="/device-recoveries"
          element={staff?.role === "admin" ? <DeviceRecoveries /> : <Navigate to="/" replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
